import React from "react";
import './index.scss';
import imgAbout from '../../assets/images/about.png'

const About = () => {
  return(
    <div className="aboutPage">
      <div className='leftCol'>
        <span className='title'>
          SUGGESTED STATIC PAGE: <br/>ABOUT OMNIYAT
        </span>
        <span className='textSub'>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
        </span>
        <span className='textSub'>
          Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        </span>
      </div>
      <div className='rightCol'>
        <img src={imgAbout} alt=""  width='100%' height='100%'/>
      </div>
    </div>
  )
};

export default About;
